import { Injectable } from '@angular/core';
import { Observable, timer } from 'rxjs';
// import 'rxjs/Rx';
import { DataService } from '../services/data.service';
import { EventBusService, EventType, ATMEventData } from '../services/eventbus.service';
import { UserNotification, IUserNotification } from '../models/usernotification';
import { TrackAuthority, ITrackAuthority } from '../models/trackauthority';
import { DataSyncService } from '../services/datasync.service';
import { Status } from '../models/status.enum';
import { LocalStorageService } from './localstorage.service';
import { DataShareService } from '../services/data-share.service';
import { IUserAlert } from '../models/useralert';

@Injectable()
export class PollService {
  private timerSubscription: any;
  private timerPoll: Observable<number>;
  private inprogress_states = [Status.AUTHORITY_REQUESTED, Status.AUTHORITY_SENT, Status.AUTHORITY_PENDING, Status.AUTHORITY_APPROVED,
  Status.AUTHORITY_USER_APPROVED, Status.AUTHORITY_USER_REJECTED, Status.RELEASE_REQUESTED, Status.RELEASE_SENT,
  Status.RELEASE_PENDING, Status.RELEASE_APPROVED, Status.RELEASE_USER_APPROVED, Status.RELEASE_USER_REJECTED];
  constructor(private dataService: DataService, private eventBus: EventBusService, private dataSyncService: DataSyncService,
    private localStorageService: LocalStorageService, private dataShareService: DataShareService) {
    this.eventBus.getEventBus(EventType.RESET_POLL_EVENT).subscribe(() => {
      this.startPoll(30000);
    });
  }

  startPoll(time: number) {
    this.stopPoll();
    this.timerPoll = timer(1000, time);
    this.timerSubscription = this.timerPoll.subscribe(() => {
      this.subscriberMethod();
    });
  }

  stopPoll() {
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }
  }

  isAuthorityInprogress(authorities: Array<TrackAuthority>): boolean {
    for (let authoritiy of authorities) {
      if (this.inprogress_states.indexOf(authoritiy.status) >= 0 || authoritiy.authorityChangeRequests.length > 0 ||
        authoritiy.isAuthorityShared) {
        return true;
      }
    }
    return false;
  }

  getAuthoritesList(): Promise<TrackAuthority[]> {
    return this.localStorageService.getAllTrackAuthorities();
  }

  getUserNotificationsList(response): Promise<IUserNotification[]> {
    return response;
  }
  subscriberMethod() {
    Promise.all([this.dataService.getUserResource(), this.dataService.getUserAlert()]).then((results: [any, IUserAlert | null]) => {
      const responseObject = results[0];
      const userAlert = results[1];

      if (userAlert && userAlert.alertMessage) {
        this.eventBus.fireEvent(
          EventType.SET_USER_ALERT_EVENT,
          new ATMEventData(userAlert, () => '')
        );
      } else {
        this.eventBus.fireEvent(
          EventType.CLEAR_USER_ALERT_EVENT,
          new ATMEventData(null, () => '')
        );
      }

      let isOutage: boolean;
      if (
        responseObject !== undefined &&
        responseObject.outageMessage !== undefined &&
        responseObject.outageMessage !== ''
      ) {
        this.eventBus.fireEvent(
          EventType.SET_OUTAGE_EVENT,
          new ATMEventData(responseObject.outageMessage, () => '')
        );
        isOutage = true;
      } else {
        this.eventBus.fireEvent(
          EventType.CLEAR_OUTAGE_EVENT,
          new ATMEventData(null, () => '')
        );
        isOutage = false;
        this.dataSyncService.performCachedActions();
      }

      if (
        responseObject !== undefined &&
        responseObject.outageMessage !== undefined &&
        responseObject.outageMessage !== '' && responseObject.regularManintenance) {
        this.eventBus.fireEvent(
          EventType.REGULARMAINTENANCE,
          new ATMEventData(null, () => '')
        );
      } else {
        this.eventBus.fireEvent(
          EventType.REGULARMAINTENANCE_CLEARED,
          new ATMEventData(null, () => '')
        );
      }

      this.localStorageService.addAllTrackAuthorities(responseObject.trackAuthorityList as ITrackAuthority[]).then(() => {
        return Promise.all([this.getAuthoritesList(), this.getUserNotificationsList(responseObject.notificationList), isOutage])
      }).then(results => {
        if (results[1].length > 0) {
          let rejectedNotifications: IUserNotification[] = [];
          rejectedNotifications = results[1].filter(
            notification => notification.message.search('Rejected Modification') >= 0 && !notification.read
          );
          if (rejectedNotifications.length > 0) {
            rejectedNotifications.reverse().map(rejectedData => {
              let authority: TrackAuthority = results[0].find(auth => rejectedData.authorityId === auth.id);
              if (authority) {
                authority.isSharedModificationRejected = true;
                authority.notificationId = rejectedData.id;
                authority.rejectedChangeRequestId = rejectedData.authorityChangeRequestId;
              }
            });
          }
        }
        this.eventBus.fireEvent(EventType.AUTHORITY_POLL_EVENT, new ATMEventData(results[0], () => ''));
        let notifications: UserNotification[] = results[1].map(item => {
          let authority = results[0].find(element => element.id === item.authorityId);
          return new UserNotification(item, authority);
        });
        this.timerSubscription.unsubscribe();
        let value = (this.isAuthorityInprogress(results[0]) || results[2]) ? 30000 : 90000;
        this.timerPoll = timer(value);
        this.timerSubscription = this.timerPoll.subscribe(() => { this.subscriberMethod(); }, (error) => console.log(error));
        this.eventBus.fireEvent(EventType.NOTIFICATION_POLL_EVENT, new ATMEventData(notifications, () => ''));
      });
    }, () => {
      this.timerSubscription.unsubscribe();
      this.timerPoll = timer(30000);
      this.timerSubscription = this.timerPoll.subscribe(() => { this.subscriberMethod(); }, err => console.log(err));
    }).catch(exception => {
      console.warn(exception);
    });
  }
}
